import React from "react";
import { TextValueTable1, TextValueTable2 } from "../styles";
import styled from "styled-components";
import { EqualIconSmall } from "../../Home/styles";
import { getCoinCodeImage } from "../../../utils/helper";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
} from "../../../utils/Currency";
import FormButton from "../../../components/FormCustom2/Button";

import { useApp } from "../../../contexts";
const Wraper = styled.div`
  // border-top: 1px solid #f2efef;
  &:first-child {
    border-top: unset;
  }
`;

export const WalletRowItemGame = ({
  coin,
  marketPrice,
  onWithdraw,
  onConvert,
  item,
  onClick,
  SourceCoin,
}) => {
  const { T, getCurrency } = useApp();
  return (
    <Wraper
      className="flex flex-col mb-3 py-[5px]"
      onClick={() => onClick?.()}
    >
      <div className="flex items-center border-b pb-2">
        <div>
          <img
            alt=""
            style={{ width: 28, height: 28 }}
            src={`/assets/images/otc/crypto/${getCoinCodeImage(
              coin
            )?.toLowerCase()}.svg`}
          />
        </div>
        <div className="ml-[12px]">
          <div className="flex">
            <TextValueTable1>{coin}</TextValueTable1>
            {SourceCoin}
          </div>
        </div>
      </div>
      <div className="flex justify-between py-3">
        <div className="flex flex-col gap-1">
          <div className="text-base font-bold leading-6">{T('Amount')}</div>
          <div className="text-base font-normal text-[#272729] leading-5">
            <NumberFormat
              value={item.amount}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={8}
            />
            </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-base font-bold leading-6">{T('BTC Value')}</div>
          <div className="text-base font-normal text-[#272729] leading-5">
            <NumberFormat
              value={item.btc}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={8}
            />
            </div>
          <div className="text-[12px] text-[#8C8D99] font-normal leading-5">
            <NumberFormat
              value={item.local}
              displayType={"text"}
              prefix={prefixCcySymbol(true, getCurrency())}
              suffix={suffixCcySymbol(true, getCurrency())}
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={validateDecimalSeparator(
                baseCurrencyCode(true, getCurrency())
              )}
            />
            </div>
        </div>
      </div>
      <div className="flex w-full py-3">
        <FormButton
          paddingLeft={20}
          paddingRight={20}
          paddingBottom={16}
          paddingTop={16}
          className="primary2 w-full"
          onClick={(e) => {e.stopPropagation(); item.coin === 'SZT' ? onConvert(item) : onWithdraw(item)}}
        >
          {T(item.coin === 'SZT' ? "Convert" : "Withdraw")}
        </FormButton>
      </div>
    </Wraper>
  );
};
